import React, { useState } from 'react';
import { X, Check } from 'lucide-react';

const DRAWING_TYPES = [
  'Architectural',
  'Structural Steel',
  'Mechanical',
  'Electrical',
  'Civil',
  'Landscape',
  'Miscellaneous',
];

/**
 * Modal to edit drawing page metadata.
 * Props:
 *  - page: { id, drawingNumber, drawingTitle, drawingType, drawingRevDate, needsReview }
 *  - onClose: function() called when closing modal
 *  - onSave: function(updates) called with updated fields
 */
const EditDrawingModal = ({ page, onClose, onSave }) => {
  const [form, setForm] = useState({
    drawingNumber: page.drawingNumber || '',
    drawingTitle: page.drawingTitle || '',
    drawingType: page.drawingType || 'Miscellaneous',
    drawingRevDate: page.drawingRevDate || '',
    needsReview: page.needsReview || false,
  });

  const handleChange = (field, value) => {
    setForm(f => ({ ...f, [field]: value }));
  };

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="relative bg-gray-900 p-6 rounded-lg text-white w-full max-w-md space-y-4">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-200">
          <X size={24} />
        </button>
        <h2 className="text-xl font-bold">Edit Drawing Metadata</h2>

        <input
          type="text"
          placeholder="Drawing Number"
          value={form.drawingNumber}
          onChange={e => handleChange('drawingNumber', e.target.value)}
          className="w-full p-2 rounded bg-gray-800"
        />

        <input
          type="text"
          placeholder="Drawing Title"
          value={form.drawingTitle}
          onChange={e => handleChange('drawingTitle', e.target.value)}
          className="w-full p-2 rounded bg-gray-800"
        />

        <select
          value={form.drawingType}
          onChange={e => handleChange('drawingType', e.target.value)}
          className="w-full p-2 rounded bg-gray-800"
        >
          {DRAWING_TYPES.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Revision Date (yyyy-mm-dd)"
          value={form.drawingRevDate}
          onChange={e => handleChange('drawingRevDate', e.target.value)}
          className="w-full p-2 rounded bg-gray-800"
        />

        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={!form.needsReview}
            onChange={e => handleChange('needsReview', !e.target.checked)}
            id="markReviewed"
          />
          <label htmlFor="markReviewed">Mark as Reviewed</label>
        </div>

        <button
          onClick={handleSubmit}
          className="flex items-center bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          <Check className="h-4 w-4 mr-1" />
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default EditDrawingModal;